var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.photo?.file?.metadata?.s?.uri)?_c('v-row',{attrs:{"justify":"space-around","align":"center","no-gutters":""}},[_c('v-col',[_c('v-avatar',[_c('img',{attrs:{"src":_vm.photo.file.metadata.s.uri}})])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }